document.addEventListener("DOMContentLoaded", () => {
  const swiperEl = document.querySelector(".announcement-bar");
  if (!swiperEl) return;

  const autoplayEnabled = swiperEl.dataset.autoplay === "true";
  const autoplaySpeed = parseInt(swiperEl.dataset.speed || 3) * 1000;
  const slidesDesktop = parseInt(swiperEl.dataset.desktopSlides || 3);
  const slidesMobile = parseInt(swiperEl.dataset.mobileSlides || 1);
  const showArrowsSetting = swiperEl.dataset.arrows === "true";
  const totalSlides = swiperEl.querySelectorAll(".swiper-slide").length;

  const swiper = new Swiper(swiperEl, {
    loop: totalSlides > slidesDesktop, // Enable loop only if enough slides
    slidesPerView: 1,
    spaceBetween: 0,
    autoplay: autoplayEnabled && totalSlides > slidesMobile
      ? {
          delay: autoplaySpeed,
          disableOnInteraction: false,
        }
      : false,
    breakpoints: {
      768: {
        slidesPerView: slidesDesktop,
      },
    },
    navigation: showArrowsSetting
      ? {
          nextEl: ".custom-next",
          prevEl: ".custom-prev",
        }
      : {},
    on: {
      init: function () {
        // Hide arrows if not enough slides to slide
        const prevArrow = swiperEl.querySelector(".custom-prev");
        const nextArrow = swiperEl.querySelector(".custom-next");
        const shouldShowArrows = showArrowsSetting && totalSlides > slidesDesktop;

        if (prevArrow && nextArrow) {
          prevArrow.style.display = shouldShowArrows ? "flex" : "none";
          nextArrow.style.display = shouldShowArrows ? "flex" : "none";
        }
      },
    },
  });
});
